import React, { Fragment } from 'react';

import { useAuth, AuthCompanyContext } from '@homesusa/auth';
import { ButtonGroupStyled, buttonGroupClasses } from './header-user.style';
import { useAnchorEl } from './use-anchor-el';
import { HeaderUserCompanies } from './header-user-companies.component';
import { ProfileButton, ProfileButtonMenu } from './profile-button.component';

export function HeaderUser(): JSX.Element {
  const companySelector = React.useContext(AuthCompanyContext);
  const { user: userProfile } = useAuth();
  const anchorUser = useAnchorEl();

  if (!userProfile) {
    return <Fragment></Fragment>;
  }

  if (companySelector.disabled) {
    return (
      <div>
        <ButtonGroupStyled aria-label='user menu' className={buttonGroupClasses.root}>
          <ProfileButton anchor={anchorUser} />
        </ButtonGroupStyled>

        <ProfileButtonMenu anchor={anchorUser} />
      </div>
    );
  }

  return <HeaderUserCompanies />;
}
